export default __webpack_public_path__ + "static/media/environmentalBg@2x.0db14be1.png";